import { AppDispatch } from '../../../@types/store'
import { InitState } from '../../reducers/root/initialState'
import { getRentControl } from '../../../api/rentControl/rentControlApi'
import {
  rentControlRequest,
  rentControlRequestCompleted,
  rentControlReset,
  rentControlSuccess,
} from '../../reducers/rentControl/rentControlFeature'
import { getDefaultLogger } from '../../../services/logger/logger'

const RENT_CONTROL_DEBOUNCE_TIMEOUT_MS = 1000
let rentControlTimer: ReturnType<typeof setTimeout>

export const fetchRentControlIfNeeded = (city: string) => async (dispatch: AppDispatch, getState: () => InitState) => {
  if (getState().rentControlFeature.city === city) {
    return
  }

  dispatch(rentControlRequest())
  try {
    const rentControlApplies = await getRentControl(city)
    if (rentControlApplies !== undefined) {
      dispatch(rentControlSuccess({ city, rentControlApplies }))
    } else {
      dispatch(rentControlReset())
    }
  } catch (error) {
    getDefaultLogger().warn('Failed to fetch rent control', error)
    dispatch(rentControlReset())
  } finally {
    dispatch(rentControlRequestCompleted())
  }
}

export const cancelRentControlFetch = () => clearTimeout(rentControlTimer)

export const fetchRentControlDebounced = (city: string) => (dispatch: AppDispatch) => {
  cancelRentControlFetch()
  rentControlTimer = setTimeout(() => {
    dispatch(fetchRentControlIfNeeded(city))
  }, RENT_CONTROL_DEBOUNCE_TIMEOUT_MS)
}
